import React from "react";
import { Label } from "reactstrap";
import { DashboardLoader } from "../../../../../components/Common/CommonButton";
import { T } from "../../constants/theme";

/** Panel card. `headerRight` is an optional slot for header-right controls
 *  (e.g. a select/dropdown) — renders after the title, pushed to the far
 *  right via the header's flex layout. Omit it and the header behaves
 *  exactly as before. */
const DashPanel = ({ title, icon, iconColor, loading, headerRight, children }) => (
  <div className="super-admin-panel">
    <div className="super-admin-panel-header d-flex align-items-center">
      {icon && (
        <i
          className={icon}
          style={{ fontSize: "16px", color: iconColor || T.blue, marginRight: "8px" }}
        />
      )}
      <Label className="mb-0" style={{ fontSize: "14px", fontWeight: 600, color: T.blue }}>
        {title}
      </Label>
      {loading && (
        <span className="ms-2">
          <DashboardLoader />
        </span>
      )}
      {headerRight && <div className="sad-panel-header-right">{headerRight}</div>}
    </div>
    <div className="super-admin-panel-body">{children}</div>
  </div>
);

export default DashPanel;
